import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { getUniqueActivePackages } from '../../../../helpers/week';
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { GoPackage } from "@react-icons/all-files/go/GoPackage";
import { useDispatch } from 'react-redux';


const Package = props => {
  const dispatch = useDispatch();
  const packages = getUniqueActivePackages(props.destinations);
  const packageOptions = Object.values(packages)?.map(({ id, name }) => ({
    value: id,
    label: name
  }));
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.PACKAGE].map(itemValue => packageOptions.find(i => +i.value === +itemValue)?.label).join(', ');
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Package</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {packageOptions.map(item => (
          <Button key={JSON.stringify(item.value)} buttonType={isFilterSelected(props.location, FILTERS.PACKAGE, item.value) ? 'FILTER_ACTIVE' : 'FILTER'} onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.PACKAGE, item.value)}>{item.label}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<GoPackage />}>{selectedFilterText || 'Package'}</Button>;
};
Package.propTypes = {
  destinations: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  className: PropTypes.string,
  filterAction: PropTypes.func.isRequired,
  filterModalToggle: PropTypes.func.isRequired
};
export default Package;
